import { Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../../shared/shared.global-service';
import { selectServiceSettings } from '../../../../store/service/service.selectors';
import {
    SERVICE_SETTINGS_VOUCHER_TYPE_DEFAULT,
    SERVICE_SETTINGS_VOUCHER_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-voucher.type';

@Injectable()
export class ServiceSettingsVoucherStore extends ComponentStoreV2Factory {

    voucherSettings = toSignal(globalStore!.select(
        selectServiceSettings(SERVICE_SETTINGS_VOUCHER_TYPE_KEY, SERVICE_SETTINGS_VOUCHER_TYPE_DEFAULT),
    ));
}
